import React from 'react';

const ControleTotal = () => {
  const controls = [
    {
      id: 'formCheck-1',
      title: 'Bloquer les administrateurs',
      description: 'Empêche les administrateurs de se connecter',
    },
    {
      id: 'formCheck-2',
      title: 'Déconnecter tous les utilisateurs',
      description:
        "Empêche les utilisateurs de s'authentifier et déconnecte ceux qui le sont",
    },
    {
      id: 'formCheck-4',
      title: 'Bloquer le partage de kilos',
      description: 'Empêche les utilisateurs de partager les kilos',
    },
    {
      id: 'formCheck-5',
      title: 'Bloquer le partage de conteneurs',
      description: 'Empêche les utilisateurs de partager les conteneurs',
    },
    {
      id: 'formCheck-3',
      title: 'Activer la publicité',
      description:
        'Permet au spot publicitaire de s’afficher sur les interfaces',
    },
  ];

  return (
    <div className="col mb-4">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="text-primary fw-bold m-0">Contrôle Total</h6>
        </div>
        <ul className="list-group list-group-flush">
          {controls.map((control) => (
            <li key={control.id} className="list-group-item">
              <div className="row align-items-center no-gutters">
                <div className="col me-2">
                  <h6 className="mb-0">
                    <strong>{control.title}</strong>
                  </h6>
                  <span className="text-xs">{control.description}</span>
                </div>
                <div className="col-auto">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={control.id}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={control.id}
                    ></label>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ControleTotal;